import React, { useState } from 'react';
import Modal from './Modal';

const RoleModal = ({ open, onClose, onSubmit, username }) => {
  const [role, setRole] = useState('');
  return (
    <Modal open={open} onClose={onClose} title={`Set Role for ${username}`}> 
      <div className="space-y-4">
        <select
          className="input-field"
          value={role}
          onChange={(e) => setRole(e.target.value)}
        >
          <option value="">Select role</option>
          <option value="admin">admin</option>
          <option value="qa">qa</option>
          <option value="user">user</option>
          <option value="super-admin">super-admin</option>
        </select>
        <div className="flex justify-end space-x-2 pt-2">
          <button onClick={onClose} className="btn-outline">Cancel</button>
          <button onClick={() => role && onSubmit(role)} disabled={!role} className="btn-primary disabled:opacity-50">Set Role</button>
        </div>
      </div>
    </Modal>
  );
};

export default RoleModal;
